<ca-card>
    <div ca-card-content>
        <ca-tabla-seguros 
            [registros]="registros" 
            [columnas]="columnas" 
            [tamanoPagina]="10" 
            [paginado]="true" ></ca-tabla-seguros>
    </div>
</ca-card>